import { useEffect, useState } from "react";
import axios from "axios";
import { Wallet } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/creatives`;
export const USD_RON = 4.5;
export const money = (usd) => `$${Number(usd || 0).toFixed(2)} (~${(Number(usd || 0) * USD_RON).toFixed(2).replace(".", ",")} lei)`;

export const CostWidget = ({ refreshKey }) => {
  const [c, setC] = useState(null);
  useEffect(() => {
    const load = () => axios.get(`${API}/costs`).then((r) => setC(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [refreshKey]);
  if (!c) return null;
  const parts = Object.entries(c.by_model || {});
  return (
    <div className="flex items-center gap-3 rounded-xl border border-zinc-800 bg-zinc-900/50 px-4 py-2.5" data-testid="cost-widget">
      <Wallet className="h-5 w-5 text-amber-400" />
      <div className="text-xs">
        <p className="font-medium text-zinc-200">Luna aceasta: <span data-testid="cost-month-total">{money(c.total_usd)}</span></p>
        <p className="text-zinc-500" title={parts.map(([k, v]) => `${k}: $${v.toFixed(2)}`).join("\n")}>{c.images} imagini · {c.videos} video{parts.length ? ` · ${parts.map(([k]) => k).join(", ")}` : ""}</p>
      </div>
    </div>
  );
};
